<div class="stepper" *ngIf="route || trips">
   <div class="stepper-progress">

  <div class="step"
       [class.done]="route"
       (click)="goTo('route')">

    <span>1</span>
    <label>Recorrido</label>

    <small *ngIf="route">Elegi el Recorrido</small>
  </div>

  <div class="step"
       [class.done]="trips"
       [class.disabled]="!route"
       (click)="route && goTo('dates')">

    <span>2</span>
    <label>Fechas</label>

    <small *ngIf="trips">Elegi las Fechas</small>
  </div>

  <div class="step"
       [class.done]="timesSelected"
       [class.disabled]="!trips"
       (click)="trips && goTo('times')">

    <span>3</span>
    <label>Horarios</label>

    <small *ngIf="timesSelected">Elegi el Horario</small>
  </div>

  <div class="step"
       [class.disabled]="!timesSelected">

    <span>4</span>
    <label>Confirmar Reserva</label>

  </div>

</div>

  <div class="stepper-summary container-sm">

    <div class="summary-block" *ngIf="route">
      <div class="label">Recorrido</div>
      <div class="value">{{ route.name }}</div>
    </div>

    <div class="summary-block" *ngIf="trips">
      <div class="label">Viajes</div>

      <div class="trip-list">
        <div class="trip-item" *ngFor="let trip of trips">
          {{ trip.date | date:'dd/MM' }}

          <span *ngIf="timesSelected">
            {{ trip.date | date:'HH:mm' }}
          </span>
        </div>
      </div>
    </div>

  </div>

</div>